// eslint-disable-next-line no-underscore-dangle
const virtualEnv = window.__virtual_env__;
const parseEnv = (environmentObject) => {
  if (virtualEnv) {
    Object.keys(environmentObject).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(virtualEnv, key)) {
        // eslint-disable-next-line no-param-reassign
        environmentObject[key] = virtualEnv[key];
      }
    });
  } else {
    // eslint-disable-next-line no-underscore-dangle
    window.__virtual_env__ = environmentObject;
  }
};

export default parseEnv;



// WEBPACK FOOTER //
// ./app/environment/parseEnv.js